<template>
  <div class="modeller-key-prompt">
    <div
      class="modal fade"
      id="modellerKeyPrompt"
      tabindex="-1"
      aria-labelledby="modellerKeyPromptLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modellerKeyPromptLabel">License key required</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              MODELLER license key is required for this operation. You can obtain it at
              <a
                href="https://salilab.org/modeller/registration.html"
                target="_blank"
              >https://salilab.org/modeller/registration.html <i class="fas fa-external-link-alt"></i></a>
              <br/>
              You need to enter the key only once. It will be stored until you clear your browser storage.
            </div>
            <form>
              <div class="form-group">
                <label for="key-value" class="col-form-label">Enter MODELLER key:</label>
                <input type="text" class="form-control" id="key-value" v-model="enteredKey" />
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-close" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary btn-apply" @click="storeKey()">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModellerKeyPrompt",
  data: function() {
    return {
      enteredKey: ""
    };
  },
  methods: {
    storeKey: function() {
      this.enteredKey && (localStorage["modellerKey"] = this.enteredKey);

      window.jQuery("#modellerKeyPrompt").modal("hide");
    }
  }
};
</script>

<style scoped>
</style>
